module.exports = __webpack_public_path__ + "6339a0ac43ebc8a6d1ccef5fde7e651d.MP3";